<template>
<div>
<navigation></navigation>
<!--Main contents-->
<div class="box_center" id="page_x">
  <h2 class="shadow" style="float: left">Help</h2>
  <ul class="articles">
  <li>
    <a><img src="/static/images/Go_Out.png" width="38px" height="38px" alt="Logout" /></a>
    <div class="article">
    <br>
    <br>
    <br>
    <br>
      <a class="title_article">Logout</a>
      <p class="text_article">This icon will log you out of the website.</p>
    </div>
    <div class="separator"></div>
  </li>
  <li>
    <router-link :to="{path: '/buy'}"><div class="img_left sprite dollar_currency_sign" title="Buy Picks"></div></router-link>
    <div class="article">
      <router-link :to="{path: '/buy'}" class="title_article">Buy Picks</router-link>
      <p class="text_article">The dollar sign takes you to the buy picks screen.</p>
    </div>
    <div class="separator"></div>
  </li>
  <li>
    <router-link :to="{path: '/testimonials'}"><div class="img_left sprite user" title="Testimonials"></div></router-link>
    <div class="article">
      <router-link :to="{path: '/testimonials'}" class="title_article">Testimonials</router-link>
      <p class="text_article">The user takes you to the testimonials screen.</p>
    </div>
    <div class="separator"></div>
  </li>
  <li>
    <router-link :to="{path: '/picks'}"><div class="img_left sprite lock" title="View Picks"></div></router-link>
    <div class="article">
      <router-link :to="{path: '/picks'}" class="title_article">View Picks</router-link>
      <p class="text_article">The lock takes you to the testimonials screen.</p>
    </div>
    <div class="separator"></div>
  </li>
  <li>
     <router-link :to="{path: '/blog'}"><div class="img_left sprite email" title="Blog"></div></router-link>
    <div class="article">
       <router-link :to="{path: '/blog'}" class="title_article">Blog</router-link>
      <p class="text_article">The @ sign takes you to the blog.</p>
    </div>
    <div class="separator"></div>
  </li>
  <li>
    <router-link :to="{path: '/tools/size'}"><div class="img_left sprite chart_up" title="Bet Calculator"></div></router-link>
    <div class="article">
      <router-link :to="{path: '/tools/size'}" class="title_article">Bet Calculator</router-link>
      <p class="text_article">This icon takes you to the bet calculator.</p>
    </div>
    <div class="separator"></div>
  </li>
  <li>
    <router-link :to="{path: '/contact'}"><div class="img_left sprite mail" title="Contact Us"></div></router-link>
    <div class="article">
      <router-link :to="{path: '/contact'}" class="title_article">Contact</router-link>
      <p class="text_article">The mail icon takes you to the contact page</p>
    </div>
    <div class="separator"></div>
  </li>
  </ul>
</div>
<!--Main contents Ends-->
</div>
</template>

<script>
import Nav from '../components/Nav.vue'
export default {
  components: {
    'navigation': Nav
  },
  data () {
    return {

    }
  },
  metaInfo: {
    title: 'Help'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Help.vue?4b630a7d